// @flow

import { Accordion2 } from "../Accordion";
import { Calendar } from "../common/DatePickerII";
import { EmptyContent } from "views/components/EmptyContent";
import { Redirect } from "react-router-dom";
import { TimeBlock } from "../common/TimeBlockGroup";
import { Step2 as TimeBlockGroup } from "views/desktop/screens/RequestReservationScreen/Step2";
import { selectCurrentReservation } from "state/reservations/selectors";
import { selectTimeblocks } from "state/reservations/selectors";
import DatePicker from "../common/DatePicker";
import React, { useDispatch, useEffect, useGlobal, useState } from "reactn";
import Skeleton from "react-loading-skeleton";
import moment from "moment-timezone";
import styled from "styled-components";
import theme from "views/resources/theme";
import type { HourBlock, Line, Reserve } from "types";
import type moment$Moment from "moment";

const MakeReservationCard = ({
	line,
	reserves,
	officeSlug,
	timezone,
	maxBookableDays,
	blocks,
	onSelect,
	v2,
}) => {
	const header = (
		<div style={{ color: theme.colors.fg_alt }}>
			{line ? line.name : <Skeleton />}
		</div>
	);
	const [unavailableDays] = useGlobal("unavailableDays");
	const [myReservations] = useGlobal("myReservations");
	const getTimeBlocks = useDispatch("getTimeBlocks");
	const excludedDays = line && unavailableDays.byLineId[line.slug];

	const [currentDate, setCurrentDate] = useState(
		moment.tz(new Date(), timezone)
	);

	const updateTimeBlocks = (date) => {
		// Resets selected block
		onSelect({});
		setCurrentDate(moment.tz(date, timezone));
		if (v2)
			getTimeBlocks({
				lineSlug: line.slug,
				officeSlug,
				date: new Date(date),
			});
	};

	if (!line) return null;

	const currentReservation = selectCurrentReservation(myReservations);
	if (currentReservation)
		return (
			<Redirect
				to={`/reserve/${officeSlug}/${line.slug}/${currentReservation}`}
			/>
		);

	return (
		<ReserveWrapper>
			<Accordion2
				header={header}
				headerStyle={{
					backgroundColor: theme.colors.secondary,
				}}
				alwaysOpen
			>
				<div>
					<h3 style={{ textAlign: "center" }}>
						Selecciona Fecha y Hora
					</h3>
					<Calendar
						onDayClick={updateTimeBlocks}
						maxFutureDays={maxBookableDays || 30}
						excludedDays={excludedDays}
					/>
					<TimeBlockGroup
						onChange={onSelect}
						date={currentDate}
						officeSlug={officeSlug}
						lineSlug={line.slug}
						v2={v2}
						tz={timezone}
					/>
				</div>
			</Accordion2>
		</ReserveWrapper>
	);
};

const TimeBlocksContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	padding: 10px 0;
	width: 100%;
`;

const ReserveWrapper = styled.div`
	background: #fff;
`;

MakeReservationCard.defaultProps = {
	blocks: [],
	reserves: [],
	open: false,
};

export default MakeReservationCard;
